<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :loading="tabela.carregamento" loading-text="Buscando convidados..." :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">CONVIDADOS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDados = true" tile color="#5b3a4b">
            <v-icon left dark>add_circle</v-icon> Adicionar convidado
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum presente encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.confirmacao`]="{ item }">
        <td>
          <v-icon v-if="item.confirmacao == true" color="success">check</v-icon>
          <v-icon v-if="item.confirmacao == false" color="error">close</v-icon>
          <v-icon v-if="item.confirmacao == null">help</v-icon>
        </td>
      </template>
      <template v-slot:[`item.checkin`]="{ item }">
        <td v-if="item.checkin">{{ transformaData(item.checkin, 'DD/MM/YYYY') }} às {{ transformaData(item.checkin, 'HH:mm:ss') }}</td>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editarItem(item)">edit</v-icon>
        <v-icon @click="enviarWhatsApp(item)">send</v-icon>
        <v-icon @click="confirmaConvidado(item)">mdi-check-circle</v-icon>
        <v-icon @click="deletarItem(item)">delete</v-icon>
        <v-icon @click="efetuaCheckin(item)">mdi-account-check</v-icon>
      </template>
      <template v-slot:[`item.horaConfirmacao`]="{ item }">
        <td v-if="item.horaConfirmacao">{{ transformaData(item.horaConfirmacao, 'DD/MM/YYYY') }} às {{ transformaData(item.horaConfirmacao, 'HH:mm:ss') }}</td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="dialogoDados" max-width="600px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.nome" outlined dense hide-details color="#5b3a4b" label="Nome"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedItem.whatsapp" outlined dense hide-details color="#5b3a4b" label="WhatsApp com DDD" v-mask="'(##) #####-####'"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editedItem.senhasExtra" outlined dense hide-details color="#5b3a4b" label="Quantidade de senhas extras" type="tel"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="fechar">Fechar</v-btn>
          <v-btn text color="success" @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoConfirmacao" max-width="600px">
      <v-card>
        <v-card-title>Confirmar presença</v-card-title>
        <v-card-text>Confirma a presença do(a) convidado(a) {{dadosItem.nome}}?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="confirmaPresenca(false)">Não confirmar</v-btn>
          <v-btn color="success" text @click="confirmaPresenca(true)">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoCheckin" max-width="350px" persistent>
      <v-card>
        <v-card-title>Realizar check-in manual</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" style="padding-left: 0px; padding-right: 0px">
                <p style="margin: 0px" class="texto">Nome: {{dadosItem.nome}}</p>
              </v-col>
              <v-col cols="12" style="padding-left: 0px; padding-right: 0px">
                <p style="margin: 0px" class="texto">Código: {{dadosItem.codigo}}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" dark depressed color="#4A148C" text @click="realizarCheckin">Validar</v-btn>
          <v-btn dark depressed color="#D32F2F" text @click="dialogoCheckin = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-actions>
      <v-btn color="#5b3a4b" @click="carregaDados" dark>
        <v-icon left>refresh</v-icon>Atualizar
      </v-btn>
    </v-card-actions>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      faixas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'WhatsApp', value: 'whatsapp' },
          { text: 'Confirmado', value: 'confirmacao' },
          { text: 'Hora Confirmação', value: 'horaConfirmacao' },
          { text: 'Senhas Extras', value: 'senhasExtra' },
          { text: 'Check-in', value: 'checkin' },
          { text: 'Validador', value: 'userValidatorCheckin.nome' },
          { text: 'Ações', value: 'action', align: 'center', sortable: true },
        ],
        carregamento: false,
        conteudo: [],
      },
      editedIndex: -1,
      editedItem: {
        codigo: '',
        nome: '',
        whatsapp: '',
        confirmacao: null,
        presenteou: false,
        senhasExtra: 0,
      },
      defaultEditedItem: {
        codigo: '',
        nome: '',
        whatsapp: '',
        confirmacao: null,
        presenteou: false,
        senhasExtra: 0,
      },
      checkin: {
        codigo: '',
        tipo: '',
        empresaId: '',
        userValidatorId: '',
      },
      dialogoDados: false,
      dialogoConfirmacao: false,
      dialogoCheckin: false,
      loading: false,
      dadosItem: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'Adicionar novo convidado' : 'Editar convidado'
      }
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      dialogoConfirmacao() {
        if (this.dialogoConfirmacao == false) {
          this.dadosItem = []
        }
      },

      dialogoCheckin() {
        if (this.dialogoCheckin == false) {
          this.dadosItem = []
        }
      },
    },

    methods: {
      async carregaDados() {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'Convidados?filter={"where":{"empresaId":"'+this.companyobj.id+'"}, "include":["userValidatorCheckin"]}')
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
          this.tabela.carregamento = false
        })
        .catch(() => {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao consultar convidados", "DESCULPE")
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      criarConvidado() {
        this.editedItem = Object.assign({}, this.defaultEditedItem)
        this.dialogoDados = true
      },

      editarItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoDados = true
      },

      async enviarWhatsApp(item) {
        this.isLoading = true
        await axios.post(baseApiUrl + 'Convidados/salvaComWhatsapp', item)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
          }
        })
      },

      async deletarItem(item) {
        var r = confirm('Deseja realmente excluir o convidado ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(baseApiUrl + 'Convidados/' + item.id)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      fechar() {
        this.dialogoDados = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultEditedItem)
          this.editedIndex = -1
        }, 300)
      },

      async salvar() {
        this.isLoading = true
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.whatsapp) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos!", "ATENÇÃO")
        } else {
          if (this.editedIndex != -1) {
            await axios.post(`${baseApiUrl}Convidados/salvaComWhatsapp`, this.editedItem)
            .then(response => {
              if (response.data) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
            })
          } else {
            this.editedItem.empresaId = this.companyobj.id
            let codigo = ''
            while (this.editedItem.codigo == '') {
              codigo = new Date().getTime().toString()
              await axios.get(baseApiUrl + 'Convidados/count?where={"codigo":"' + codigo + '"}').then(response => {
                if (response.data.count == 0) {
                  this.editedItem.codigo = codigo
                }
              })
            }
            await axios.post(`${baseApiUrl}Convidados/salvaComWhatsapp`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Convidado cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao cadastrar convidado, tente novamente", "DESCULPE")
            })
          }
          this.fechar()
        }
      },

      async confirmaConvidado(item) {
        this.dadosItem = item
        this.dialogoConfirmacao = true
      },

      async confirmaPresenca(confirmacao) {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#0288D1","Confirmação efetuada!","INFORMAÇÃO");
        this.dadosItem.confirmacao = confirmacao
        this.dadosItem.horaConfirmacao = moment().toISOString()
        await axios.patch(baseApiUrl + 'Convidados', this.dadosItem)
        .then(response => {
          if (response.data) {
            this.dialogoConfirmacao = false
            this.carregaDados()
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao atualizar confirmação", "DESCULPE")
        })
      },

      efetuaCheckin(item) {
        this.checkin.codigo = item.codigo
        this.checkin.tipo = 'CHECKIN'
        this.checkin.empresaId = this.companyobj.id
        this.checkin.userValidatorId = this.user.id
        this.dadosItem = item
        this.dialogoCheckin = true
      },

      async realizarCheckin() {
        var vm = this
        this.loading = true
        await axios.post(`${baseApiUrl}Convidados/checkin`, this.checkin)
        .then(response => {
          if (response.data) {
            switch (response.data.codigo) {
              case 3:
                //'Checkin confirmado
                this.loading = false
                this.dialogoCheckin = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Check-in realizado com sucesso!", "INFORMAÇÃO")
                break;
              case 1:
                //'Checkin ja realizado'
                this.dialogoCheckin = false
                this.loading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Check-in já realizado!", "INFORMAÇÃO")
                break;
              default:
                break;
            }
          } else {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
        })
        await this.carregaDados()
        this.checkin.codigo = ''
        this.checkin.tipo = ''
        this.checkin.empresaId = ''
        this.checkin.userValidatorId = ''
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>